import { CoreContext } from 'context/CoreContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { Update } from 'services/cobranca';
import Wrapper from '../Wrapper';
//import { FormText } from "ui/styled";
import Button from 'components/Form/Button';
import { CompanyButtonContainer, FormText } from '../BankingCobranca/styled';

const BankingCobranca = ({ dados, reload }) => {
  const { setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  //console.log(dados)
  //variavel com o valor de quantos titulos tem vencidos para mostrar no modal
  const titulosVencidos =
    dados?.titulos?.filter((titulo) => titulo.status === 'vencido').length || 0;

  const handleError = (error) => {
    const errorMessages = {
      400: 'Dados inválidos. Verifique as informações enviadas.',
      401: 'Você não tem permissão para realizar esta ação.',
    };
    const defaultError =
      'Ocorreu um erro ao processar a requisição. Tente novamente mais tarde.';
    const errorMessage = errorMessages[error.response?.status] || defaultError;
    toast.error(errorMessage);
  };
  const handleRenegociar = async () => {
    if (!dados?.id) {
      toast.error(
        'Não foi possível renegociar. Informações do título ausentes.'
      );
      return;
    }
    setLoading(true);

    const payload = { id: dados.id, status: 'renegociar' };
    try {
      await Update({ data: payload }, dados.id);
      toast.success('Título enviado para renegociação com sucesso.');
      setModal(null);
      if (reload) {
        reload();
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper title="Renegociar Título">
      <FormText>
        Deseja enviar a cobrança com id:{dados?.id} do(a) cliente:
        {dados?.cliente?.nome_completo}, tendo {titulosVencidos} títulos
        vencidos, para renegociação?
      </FormText>
      <CompanyButtonContainer>
        <Button onClick={handleRenegociar} disabled={loading} color="blue">
          {loading ? 'Enviando...' : 'Sim, enviar para renegociação'}
        </Button>
        <Button
          onClick={() => setModal(null)}
          disabled={loading}
          variant="secondary"
          color="info"
        >
          Cancelar
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
};
BankingCobranca.propTypes = {
  dados: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  reload: PropTypes.func,
};
export default BankingCobranca;
